import { useState, useEffect } from "react";
import { Analytics } from "@vercel/analytics/react"
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";

import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisterCreator from "./pages/RegisterCreator";
import VerifyEmail from "./pages/VerifyEmail";
import Dashboard from "./pages/Dashboard";
import CreateService from "./pages/CreateService"; // <-- importer le composant
import ModifierProfil from "./pages/ModifierProfil";
import Profile from "./pages/Profile";
import ServiceList from "./pages/ServiceList";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ServiceDetail from "./pages/ServiceDetail";
import UserProfile from "./pages/UserProfile";
import Messagerie from "./components/Messagerie";
import MessagerieList from "./components/MessagerieList";
import EditService from "./pages/EditService";
import CompleterProfil from "./pages/CompleterProfil";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Footer from "./components/Footer";
import CreatorsList from "./pages/CreatorsList";
import SiteEnConstruction from "./pages/SiteEnConstruction";
import { getAdminSession, isAdminUser } from "./utils/adminAuth";

const hasValidAdminSession = () => {
  const adminSession = getAdminSession();
  return Boolean(adminSession.token && isAdminUser(adminSession.user));
};

const RequireAdminAuth = ({ children }) => {
  if (!hasValidAdminSession()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

const RedirectAdminIfAuthenticated = ({ children }) => {
  const location = useLocation();
  const forceLogoutView =
    new URLSearchParams(location.search).get("logout") === "1";

  if (forceLogoutView) {
    return children;
  }

  if (hasValidAdminSession()) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
};

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  const [currentUserId, setCurrentUserId] = useState(null);

const { user, loading } = useContext(AuthContext);


  useEffect(() => {
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");

  let userId = null;
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      userId = user?.id || user?._id || null;
    } catch (e) {
      console.warn("Invalid user in localStorage", e);
    }
  }

  if (token && userId) {
    setCurrentUserId(userId);
  }

}, []); // ✅ Pas de dépendance nécessaire


if (loading) return <div>Chargement...</div>;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<SiteEnConstruction />} />
        <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register-creator" element={<RegisterCreator />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/completer-profil" element={<CompleterProfil />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route
          path="/admin/login"
          element={
            <RedirectAdminIfAuthenticated>
              <AdminLogin />
            </RedirectAdminIfAuthenticated>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <RequireAdminAuth>
              <AdminDashboard />
            </RequireAdminAuth>
          }
        />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ServiceList" element={<><ServiceList /><Footer /></>} />
        <Route path="/service/:id" element={<ServiceDetail />} />
        <Route path="/createurs" element={<CreatorsList />} />
        <Route path="/users/:id" element={<UserProfile />} />

        <Route
          path="/create-service"
          element={
            <RequireAuth>
              <CreateService />
            </RequireAuth>
          }
        />
        <Route
          path="/modifier-profil"
          element={
            <RequireAuth>
              <ModifierProfil />
            </RequireAuth>
          }
        />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/editService/:id"
          element={
            <RequireAuth>
              <EditService />
            </RequireAuth>
          }
        />
        <Route
          path="/messagerie/:otherId"
          element={
            <RequireAuth>
              <Messagerie currentUserId={currentUserId} />
            </RequireAuth>
          }
        />
        <Route
          path="/messagerie"
          element={
            <RequireAuth>
              <MessagerieList currentUserId={currentUserId} />
            </RequireAuth>
          }
        />



        {/* Tu peux ajouter d'autres routes ici plus tard (create-service, profile, etc.) */}
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
